export const queryParams = {
    pageNumber: "pageNumber",
    pageSize: "pageSize",
    type: "type",
    search: "search",
} as const;
